import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubTabBar } from './SubTabBar';
import Taxonomy from './Taxonomy';
import Aliases from './Aliases';

/** Consolidated entity curation: taxonomy dedupe + brand/advertiser aliases. */
export default function Normalization() {
  const { t } = useTranslation('admin');
  const [tab, setTab] = useState<'taxonomy' | 'aliases'>('taxonomy');
  return (
    <>
      <SubTabBar active={tab} onChange={(v) => setTab(v as 'taxonomy' | 'aliases')} tabs={[
        { v: 'taxonomy', label: t('normTab.taxonomy', { defaultValue: 'Таксономия' }) as string },
        { v: 'aliases', label: t('normTab.aliases', { defaultValue: 'Алиасы' }) as string },
      ]} />
      {tab === 'taxonomy' ? <Taxonomy /> : <Aliases />}
    </>
  );
}
